import { c as _c } from "react/compiler-runtime";
import type { Color } from '@onefootprint/design-tokens';
import type { Icon } from '@onefootprint/icons';
import { cx } from 'class-variance-authority';
import type { JSX } from 'react';
type FeedbackIconProps = {
  imageIcon: {
    component: Icon;
    color?: Color;
  };
  statusIndicator: {
    component: JSX.Element;
    status: 'loading' | 'error' | 'success';
    backgroundColor?: 'primary' | 'secondary';
  };
};
const FeedbackIcon = t0 => {
  const $ = _c(15);
  const {
    imageIcon: t1,
    statusIndicator: t2
  } = t0;
  const {
    component: ImageIcon,
    color: imageIconColor
  } = t1;
  const {
    component: statusIndicatorComponent,
    status,
    backgroundColor: t3
  } = t2;
  const backgroundColor = t3 === undefined ? "primary" : t3;
  const t4 = imageIconColor ?? "primary";
  let t5;
  if ($[0] !== ImageIcon || $[1] !== t4) {
    t5 = <ImageIcon color={t4} />;
    $[0] = ImageIcon;
    $[1] = t4;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  const t6 = backgroundColor === "primary" ? "border-primary" : "border-secondary";
  const t7 = status === "loading" && "bg-warning";
  const t8 = status === "error" && "bg-error";
  const t9 = status === "success" && "bg-success";
  let t10;
  if ($[3] !== t6 || $[4] !== t7 || $[5] !== t8 || $[6] !== t9) {
    t10 = cx("absolute flex justify-center -right-5 -bottom-3 border-4 border-solid rounded-full p-1", t6, t7, t8, t9);
    $[3] = t6;
    $[4] = t7;
    $[5] = t8;
    $[6] = t9;
    $[7] = t10;
  } else {
    t10 = $[7];
  }
  let t11;
  if ($[8] !== status || $[9] !== statusIndicatorComponent || $[10] !== t10) {
    t11 = <div className={t10} data-status={status}>{statusIndicatorComponent}</div>;
    $[8] = status;
    $[9] = statusIndicatorComponent;
    $[10] = t10;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  let t12;
  if ($[12] !== t11 || $[13] !== t5) {
    t12 = <div className="relative w-10 h-10 p-1">{t5}{t11}</div>;
    $[12] = t11;
    $[13] = t5;
    $[14] = t12;
  } else {
    t12 = $[14];
  }
  return t12;
};
export default FeedbackIcon;